import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService, TranslationRepos } from './translate.service';
import { Observable } from 'rxjs';

@Pipe({
  name: 'tkdata',
})
export class TranslateKDataPipe implements PipeTransform {


  constructor(private translateService: TranslateService) {}
  transform(value: any, type: TranslationRepos, options: {default: string | undefined},  ...args: unknown[]): Observable<string> {
    return this.translateService.translateKopData(type, value, options.default);
  }

}
